import type { FaireProductEntity } from "../../entity_types/product";

export const p_gd3dqay6e2: FaireProductEntity = {
  token: "p_gd3dqay6e2",
  type: "product",
  name: "Black Coconut Wax Candle with Crackling Wood Wick",
  brandToken: "b_9vum56uxv5",
  brandName: "JAEMI GOODS",
  imageUrl:
    "https://cdn.faire.com/fastly/8a2763e4426d1da032d4da148f7b16fae7e4aeb3ab927bb3e322831d20ac248c.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/d341308ba0849f7e96d82481fcc4c9ae9f57c20c64cc7ce9ccc7c3251aa0cd28.jpeg",
    "https://cdn.faire.com/fastly/9dd243ee93278b6bddf8b32f1170229154bc82af2c09cdf9a5fd7c46d817af2d.jpeg",
    "https://cdn.faire.com/fastly/82375ea6d15a731bd5f6ae27e0cbe4f8a7b532a87a02911c9e7caaaa087629f5.jpeg",
    "https://cdn.faire.com/fastly/cdb1ae8ac60465e8b5e1b2cac4957c40b01953dddf7f7d39fb1ccfe749ff8c93.jpeg",
    "https://cdn.faire.com/fastly/17dabf6afc3427c5e5e801e9be852179333d1cfeb9aa4dc95919c40a67e09293.jpeg",
    "https://cdn.faire.com/fastly/670835ab9d56799086ad2b8ef4a71d97252bda11280e07ccb794493dfccb0fcf.jpeg",
    "https://cdn.faire.com/fastly/2d2fd68f707faeeebcb8d27c82ca821e2f0ed183924ab624297937aba0d66852.jpeg",
  ],
  priceDollars: 22.5,
  description:
    'Elevate your space with our Black Candle — minimalist home decor, relaxation, and cozy ambiance in one beautiful coconut wax candle. This elegant white scented candle is perfect for gifting, self-care rituals, meditation, weddings, housewarmings, and everyday luxury.\n\nCrafted with care from a premium, premium natural coconut wax and a single-ply crackling wood strip wick, this candle delivers a long, even fragrance release that fills rooms with soothing atmosphere. The crisp black ceramic jar design complements modern, farmhouse, boho, and minimalist interior styles — making it a versatile accent for living rooms, bedrooms, bathrooms, offices, and small spaces.\n\nProduct Details:\n• Scent: Smokey Mist\n• Wax: Premium natural coconut wax\n• Wick: Single-ply crackling wood strip\n• Size: 12 ounces\n• Dimensions: 3 ⅞" x 3 ¼"\n• Limited Edition Small Batch of 150 candles\n\nJAEMI GOODS is a “fun” inspired brand that brings playfulness to the home. We seek to incorporate fun, simple elements into everyday living with the purpose to bring smiles & joy to the world around us.\n\nJaemi (재미) comes from the Korean word for FUN - 재미.',
  tags: [],
  msrpDollars: 45,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-01T22:13:10.957Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
